<template>
    <div class="block lg:hidden">
        <div class="relative flex items-center justify-center shadow-md py-2">
            <div class="absolute top-0 left-4 topbar-height flex items-center" @click="clickBack()">
                <img class="back-icon" src="../../../../../assets/arrow/back-btn.svg">
            </div>
            <img class="logo-bk" src="../../../../../assets/logo/Logo.svg">
            <div class="absolute top-0 topbar-height flex items-center" :class="[isShowCart ? 'right-4': 'right-3']">
                <div class="point-label  text-center text-a-egg-f5ebdc text-12">
                    {{ userPoint }}
                </div>
                <template v-if="isShowCart">
                    <div class="relative" @click="clickCart()">
                        <img class="w-26px" src="@/assets/icon/ic-bag-brown.svg">
                        <div v-show="cartCount > 0"
                            class="bg-a-red-d62300 text-a-egg-f5ebdc text-12 absolute rounded-full -top-1 -right-3 py-0.5 px-1.5">
                            {{ cartCount }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { computed, inject } from 'vue';
// mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin'

export default {
    mixins: [AuthStatusMixin],
    inject: ['SideMenuStore'],
    setup: function () {
        const config = inject("LayoutConfig")
        const CartCountStore = inject("CartCountStore")

        const cartCount = computed(()=>{
            return CartCountStore.state.cartCount
        })

        const isShowCart = computed(() => {
            let flag = config.value?.topBar?.right?.showCart ?? false
            return flag
        })

        return {
            cartCount,
            isShowCart,
        }
    },
    methods: {
        clickBack: function () {
            if (this.$route.name == "subscription" && this.$route.query.from == "shoppingcart") {
                this.$router.replace('/reward')
            } else {
                this.$router.back();
            }
        },
        clickCart: function () {
            if (this.isGuestAccountRegistered || this.isLoginAccount) {
                this.SideMenuStore.methods.openShoppingBag();
            } else {
                let path = this.$route.path;
                this.$router.push({
                    name: 'login',
                    query: {
                        afterLogin: path,
                    },
                });
            }
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.topbar-height {
    height: $topbar-height;
}

.logo-bk {
    height: $bk-logo-height;
}

.point-label {
    width: 50px;
    height: 32px;
    padding: 11px 0px;
    background-image: url('../../../../../assets/icon/crown-red.svg');
    background-repeat: no-repeat;
    background-size: 32px;
    background-position-x: center;
    background-position-y: center;
}

.back-icon {
    height: 18px;
}
</style>
